module.exports = __webpack_public_path__ + "img/plus.197b7ff0.svg";